import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from '../reducers/userReducer';
import reportsReducer from '../reducers/reportsReducer';
import {
	persistStore,
	persistReducer,
	PERSIST
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import expireReducer from 'redux-persist-expire';
import projectsReducer from '../reducers/projectsReducer';
import employeesReducer from '../reducers/allEmployeeReducer';
import lastEvaluatedKeyReducer from '../reducers/lastEvaluatedKeyReducer';
import exceptioReportsReducer from '../reducers/exceptionReportsReducer';
import notificationReducer from '../reducers/notificationReducer';
import monthlyReportsReducer from '../reducers/monthlyReport';
import monthlySummaryReducer from '../reducers/monthlySummaryReducer';
import quotesReducer from '../reducers/quotesReducer';
import holidayReducer from '../reducers/holidayReducer';
import impLinkReducer from '../reducers/impLinkReducer';
import blogReducer from '../reducers/blogReducer';
import homeReducer from '../reducers/homeReducer';
import rewardsReducer from '../reducers/rewardsReducer';
import staffReducer from '../reducers/staffsReducer';
import isDataAvailableReducers from '../reducers/isDataAvailableReducers';
import homeLastEvaluatedKeyReducer from '../reducers/homelastEvaluatedKeyReducer';
import rewardsLastEvaluatedKeyReducer from '../reducers/rewardslastEvaluatedKayReducer';
import staffLastEvaluatedKeyReducer from '../reducers/stafflastEvaluatedKayReducer';
import goalsReducer from '../reducers/goalsReducer';
import blogsReducer from '../reducers/blogsReducer';
import blogsLastEvaluatedKeyReducer from '../reducers/blogsLastEvaluatedKeyReducer';
import workReviewReducer from '../reducers/workReviewReducer';

const rootReducer = combineReducers({
	user: userReducer.reducer,
	reports: reportsReducer.reducer,
	projects: projectsReducer.reducer,
	employees: employeesReducer.reducer,
	lastEvaluatedKey: lastEvaluatedKeyReducer.reducer,
	exceptionReports: exceptioReportsReducer.reducer,
	notification: notificationReducer.reducer,
	monthlyReport: monthlyReportsReducer.reducer,
	monthlySummary: monthlySummaryReducer.reducer,
	quotes: quotesReducer.reducer,
	holiday: holidayReducer.reducer,
	impLink: impLinkReducer.reducer,
	blog:blogReducer.reducer,
	homeAvailable: isDataAvailableReducers.reducer,
	homeReducer:homeReducer.reducer,
	rewardsReducer:rewardsReducer.reducer,
	staffReducer:staffReducer.reducer,
	homeLastEvaluatedKeyReducer:homeLastEvaluatedKeyReducer.reducer,
	rewardsLastEvaluatedKeyReducer:rewardsLastEvaluatedKeyReducer.reducer,
	staffLastEvaluatedKeyReducer:staffLastEvaluatedKeyReducer.reducer,
	goals: goalsReducer.reducer,
	blogsReducer: blogsReducer.reducer,
	blogsLastEvaluatedKeyReducer: blogsLastEvaluatedKeyReducer.reducer,
	workReview: workReviewReducer.reducer



});

const persistConfig = {
	key: 'root',
	storage,
	transforms: [expireReducer(rootReducer, { expireSeconds: 10 })]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: getDefaultMiddleware => {
		return getDefaultMiddleware(
			{ serializableCheck: { ignoreActions: [PERSIST], }, }
		);
	},
});

export const persistor = persistStore(store);
